import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';
import { catchError, combineLatest, map, Observable, throwError } from 'rxjs';
import { DetailedTdRateFiduciary, TdRateFiduciary, TdRateFiduciaryToAddOrUpdate } from './td-rate-fiduciary.model';

@Injectable({
  providedIn: 'root'
})
export class TdRatesFiduciariesService {
  private apiEndpoint = `${environment.apiEndpoint}/api/td-rates-fiduciaries`;

  constructor(
    private http: HttpClient,
    private logger: NGXLogger
  ) {}

  public getTdRateFiduciaries$(): Observable<TdRateFiduciary[]> {
    return this.http.get<TdRateFiduciary[]>(this.apiEndpoint).pipe(
      catchError((error: any) => {
        this.logger.error(error);
        return throwError(() => error);
      })
    );
  }

  public getTdRateFiduciary$(id: number): Observable<DetailedTdRateFiduciary> {
    return this.http.get<DetailedTdRateFiduciary>(`${this.apiEndpoint}/${id}`).pipe(
      catchError((error: any) => {
        this.logger.error(error);
        return throwError(() => error);
      })
    );
  }

  public insertTdRateFiduciary$(tdRateFiduciary: TdRateFiduciaryToAddOrUpdate): Observable<DetailedTdRateFiduciary> {
    return this.http.post<DetailedTdRateFiduciary>(this.apiEndpoint, tdRateFiduciary).pipe(
      catchError((error) => {
        this.logger.error(error);
        return throwError(() => error);
      })
    );
  }

  public updateTdRateFiduciary$(
    id: number,
    tdRateFiduciary: TdRateFiduciaryToAddOrUpdate
  ): Observable<DetailedTdRateFiduciary> {
    return this.http.put<DetailedTdRateFiduciary>(`${this.apiEndpoint}/${id}`, tdRateFiduciary).pipe(
      catchError((error) => {
        this.logger.error(error);
        return throwError(() => error);
      })
    );
  }

  public deleteTdRateFiduciary$(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiEndpoint}/${id}`).pipe(
      catchError((error) => {
        this.logger.error(error);
        return throwError(() => error);
      })
    );
  }

  public deleteMultipleTdRateFiduciaries$(ids: number[]): Observable<void> {
    return combineLatest(ids.map((id) => this.deleteTdRateFiduciary$(id))).pipe(map(() => {}));
  }
}
